import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FilterModel } from '../models/FilterModel';
import { AppliedFilterModel } from '../models/AppliedFilterModel';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'lib-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit {
  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    //Adding Input Filters to Default Filters
    if(this.filters.length > 0){
      this._filters =[...this._filters, ...this.filters, ];
    }
    /* Creating a form group with two form arrays. One for the filters and one for the checkboxes. */
    this.dynamicForm = new FormGroup({
      formFilters: new FormArray([]),
      formCheckBoxes: new FormArray([]),
    });

    for (
      let i = this.formFilterControls.length;
      i < this._filters.length;
      i++
    ) {
      if (this._filters[i].type == 'multiselect') {
        this.formFilterControls.push(
          this.formBuilder.group({
            name: new FormControl(
              { value: this._filters[i].name, disabled: true },
              Validators.required
            ),
            condition: new FormControl(
              { value: '', disabled: true },
              Validators.required
            ),
            value: [{ value: [], disabled: true }],
          })
        );
      } else {
        this.formFilterControls.push(
          this.formBuilder.group({
            name: new FormControl(
              { value: this._filters[i].name, disabled: true },
              Validators.required
            ),
            condition: new FormControl(
              { value: '', disabled: true },
              Validators.required
            ),
            value: new FormControl(
              { value: '', disabled: true },
              Validators.required
            ),
          })
        );
      }
      (<FormArray>this.dynamicForm.controls.formCheckBoxes).push(
        new FormControl(false)
      );
    }
  }

  @Input() filters: FilterModel[] = [];

  appliedFilter: AppliedFilterModel[] = [];

  selectedFilter: number = 0;

  FilterCondition = {
    number: ['equal', 'not equal', 'greater than', 'smaller than'],
    string: ['contains', 'not contains', 'equal', 'not equal'],
    array: ['contains', 'not contains', 'equal', 'not equal'],
    boolean: ['equal'],
    multiselect: ['contains', 'not contains', 'equal', 'not equal'],
  };

  dynamicForm: FormGroup = {} as FormGroup;

  // convenience getters for easy access to form fields
  /* A getter function that returns the form control - Form Filters of the form. */
  get formFilterControls() {
    return this.dynamicForm.controls.formFilters as FormArray;
  }
  /* A getter function that returns the form checkbox of the form. */
  get formCheckBoxControls() {
    return this.dynamicForm.controls.formCheckBoxes as FormArray;
  }

  @Output() filterApplied: EventEmitter<any> = new EventEmitter<any>();
  @Output() removeFilters: EventEmitter<any> = new EventEmitter<any>();

  //Deafult Filters
  _filters: FilterModel[] = [
    {
      name: 'Event Name',
      type: 'string',
      values: [],
    },
    {
      name: 'Device Name',
      type: 'string',
      values: [],
    },
  ];

  /**
   * It enables or disables the input fields of the filter form based on the checkbox value of form
   * @param {number} index - number - the index of the filter in the form array
   * @param {boolean} bool - boolean - This is the checkbox value that is passed from HTML.
   */
  disableEnableInput(index: number, bool: boolean) {
    console.log(index, bool);
    if (bool === true) {
      this.formFilterControls.controls[index].get('name')?.enable();
      this.formFilterControls.controls[index].get('condition')?.enable();
      this.formFilterControls.controls[index].get('value')?.enable();
      this.selectedFilter++;
    } else {
      this.formFilterControls.controls[index].get('name')?.disable();
      this.formFilterControls.controls[index].get('condition')?.disable();
      this.formFilterControls.controls[index].get('value')?.disable();
      this.selectedFilter--;
    }
  }

  /**
   * The function is called when the user clicks on the submit button. It checks if the form is valid
   * and if it is, it emits the form values to the parent component and Emits an event that filter is applied to Event-Card Component
   * @returns The form values are being returned.
   */
  onSubmitFilterForm() {
    if (this.dynamicForm.invalid) {
      alert('Please fill all the fields');
      return;
    }
    if (this.selectedFilter > 0) {
      // display form values on success
      console.log(
        'your form has submitted' + this.dynamicForm.value.formFilters
      );

      this.filterApplied.emit(this.dynamicForm.value.formFilters);
    }
  }

  /**
   * It loops through the filters, sets the checkbox to false, sets the formcontrol (value and condition) to empty,
   * and disables the input and Emits an event that filter are removed to Event-Card Component
   */
  onClearFilterForm() {
    for (let i = 0; i < this._filters.length; i++) {
      this.formCheckBoxControls.controls[i].setValue(false);
      this.formFilterControls.controls[i].get('condition')?.setValue('');
      if (this._filters[i].type == 'multiselect') {
        (
          this.formFilterControls.controls[i].get('value') as FormArray
        ).setValue([]);
      } else {
        this.formFilterControls.controls[i].get('value')?.setValue('');
      }

      this.disableEnableInput(i, false);
    }
    this.selectedFilter = 0;
    this.removeFilters.emit();
  }

  /**
   * If the value is already in the array, remove it. If it's not, add it
   * @param {any} value - any - the value of the checkbox
   * @param {number} i - number - the index of the control in the form array
   */
  addRemoveValueToControl(value: any, i: number) {
    if (
      this.formFilterControls.controls[i].get('value')?.value.includes(value)
    ) {
      this.formFilterControls.controls[i]
        .get('value')
        ?.value.splice(
          this.formFilterControls.controls[i]
            .get('value')
            ?.value.indexOf(value),
          1
        );
    } else {
      this.formFilterControls.controls[i].get('value')?.value.push(value);
    }
  }

  /**
   * It returns the value of the form control at the given index
   * @param {number} i - number - the index of the form control in the form array
   * @returns The value of the form control at index i.
   */
  getValueOfFormControl(i: number) {
    return this.formFilterControls.controls[i].get('value')?.value;
  }
}
